import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { ModalFooterComponent } from '../modal-footer/modal-footer.component';
import { DialogRef } from '@angular/cdk/dialog';
import { Router } from '@angular/router';
import { AppRouting } from '@core/enums';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@core/pipes';
import { ButtonComponent } from '../button/button.component';
import { SvgComponent } from '../svg/svg.component';

@Component({
    selector: 'sc-pending-payment-modal',
    imports: [
        ModalComponent,
        ButtonComponent,
        ModalFooterComponent,
        SvgComponent,
        AsyncPipe,
        TranslatePipe,
    ],
    templateUrl: './pending-payment-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingPaymentModalComponent {
  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    private readonly router: Router
  ) {}

  public close(approved: boolean) {
    if (approved) {
      this.router.navigate([`/${AppRouting.Invoices}`]);
    }
    this.dialogRef.close(approved);
  }
}
